import type { ListingStage } from '@/api/v4/project-listings.api';
import {
  DealStageName,
  ListingStageName,
} from '@/features/listing-stage/types';

import type { SpotlightStagePillStageKey } from '@/features/spotlight/stage-pills/spotlight-stage-pill.types';

const normalizeStageName = (stageName: string | null | undefined): string =>
  (stageName ?? '').replace(/[^a-z0-9]/gi, '').toLowerCase();

const DEAL_STAGE_NAMES = new Set([
  normalizeStageName(ListingStageName.deal),
  normalizeStageName(DealStageName.implementation),
  normalizeStageName(DealStageName.otherTransaction),
]);
const INVESTMENT_STAGE_NAMES = new Set([
  normalizeStageName(DealStageName.investment),
]);
const PILOT_STAGE_NAMES = new Set([normalizeStageName(ListingStageName.pilot)]);

const getSpotlightStagePillKeyForStageName = (
  stageName: string,
): SpotlightStagePillStageKey | null => {
  const normalizedStageName = normalizeStageName(stageName);

  if (!normalizedStageName) {
    return null;
  }

  if (DEAL_STAGE_NAMES.has(normalizedStageName)) {
    return 'deal';
  }

  if (INVESTMENT_STAGE_NAMES.has(normalizedStageName)) {
    return 'investment';
  }

  if (PILOT_STAGE_NAMES.has(normalizedStageName)) {
    return 'pilot';
  }

  return null;
};

const EDITORS_CHOICE_STAGE_NORMALIZED = 'editorschoice';

export const getSpotlightStagePillKeyForListingStage = (
  stage: Pick<ListingStage, 'displayName' | 'name'>,
): SpotlightStagePillStageKey | null => {
  if (stage.displayName) {
    const pillKeyFromDisplayName = getSpotlightStagePillKeyForStageName(
      stage.displayName,
    );

    if (pillKeyFromDisplayName) {
      return pillKeyFromDisplayName;
    }

    if (
      normalizeStageName(stage.displayName) === EDITORS_CHOICE_STAGE_NORMALIZED
    ) {
      return null;
    }
  }

  return getSpotlightStagePillKeyForStageName(stage.name);
};
